import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClockSkewService {
  // 120 seconds threshold exceeding which will throw clock-skew error
  private readonly clockSkewThresholdMs = 120 * 1000;

  // Until we can read "Date" from response headers, use this with "expires" header
  private readonly oneDayMs = 24 * 60 * 60 * 1000;

  constructor(private http: HttpClient) {}

  async isClockSkewed(): Promise<boolean> {
    const response = await firstValueFrom(
      this.http.get(
        environment.NmdpConfig.authority +
        '/.well-known/openid-configuration' +
        `?clockCheck=${Date.now()}`,
        { observe: 'response' }
      )
    );

    const dateHeader = response.headers.get('date');
    const expiresHeader = response.headers.get('expires');

    const serverTime = dateHeader
      ? Date.parse(dateHeader)
      : expiresHeader
        ? Date.parse(expiresHeader) - this.oneDayMs
        : NaN;

    if (Number.isNaN(serverTime)) {
      throw new Error('Invalid Date header returned by Okta.');
    }

    const skewMs = Math.abs(Date.now() - serverTime);

    return skewMs > this.clockSkewThresholdMs;
  }
}
